import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            视频分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">多种分类，满足不同喜好</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-center gap-3 p-3 md:p-4 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex-shrink-0 flex items-center justify-center bg-primary-50 rounded-lg group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl text-primary-500`}></i>
              </div>
              <div className="min-w-0">
                <div className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {cat.name}
                </div>
                <div className="text-xs text-foreground-500 mt-0.5">
                  {cat.count} 个视频
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}